export enum RoleNames {
  OBJECTS_READ = "objects.read",
  OBJECTS_WRITE = "objects.write",
  ADMIN = "admin"
}
